// src/components/organisms/ClientForm.jsx
import React from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Alert,
  Typography,
} from "@mui/material";
import { CLIENT_TYPES, STAGES } from "../../constants/clientConstants";

export default function ClientForm({ form, errors, serverError, onChange, onBlur }) {
  const field = (name, props = {}) => ({
    fullWidth: true,
    size: "small",
    value: form[name],
    onChange: onChange(name),
    onBlur: onBlur ? onBlur(name) : undefined,
    error: !!errors[name],
    helperText: errors[name] || props.helperText || "",
    ...props,
  });

  return (
    <Grid container spacing={2}>
      {serverError && (
        <Grid item xs={12}>
          <Alert severity="error">{serverError}</Alert>
        </Grid>
      )}

      {/* Row 1: Names */}
      <Grid item xs={12} sm={6}>
        <TextField {...field("firstName", { label: "First Name", required: true })} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField {...field("lastName", { label: "Last Name", required: true })} />
      </Grid>

      {/* Row 2: Contact */}
      <Grid item xs={12} sm={6}>
        <TextField {...field("email", { label: "Email", type: "email", placeholder: "client@example.com" })} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField {...field("phone", { label: "Phone", type: "tel", placeholder: "+1 555-123-4567" })} />
      </Grid>

      {/* Row 3: Type / Source / Stage */}
      <Grid item xs={12} sm={4}>
        <TextField {...field("clientType", { label: "Client Type", select: true })} >
          <MenuItem value=""><em>None</em></MenuItem>
          {CLIENT_TYPES.map((o) => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField {...field("leadSource", { label: "Lead Source", placeholder: "Referral, Zillow…" })} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField {...field("stage", { label: "Stage", select: true })} >
          {STAGES.map((o) => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
        </TextField>
      </Grid>

      {/* Row 4: Dates */}
      <Grid item xs={12} sm={6}>
        <TextField
          {...field("birthday", { label: "Birthday", type: "date" })}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          {...field("anniversary", { label: "Anniversary", type: "date" })}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* Row 5: Notes */}
      <Grid item xs={12}>
        <TextField
          {...field("notes", { label: "Notes", multiline: true, rows: 3 })}
          inputProps={{ maxLength: 2000 }}
          helperText={
            errors.notes || (
              <Typography variant="caption" color="text.secondary">
                {form.notes.length}/2000
              </Typography>
            )
          }
        />
      </Grid>
    </Grid>
  );
}
